import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';
import BaseFormat from '@/plugins/baseFormat';

const getOccurrence = (driverId,
  {
    status,
    code,
    occurrence_date,
    reason,
    financial_occ_type,
    value,
    page,
    sort,
    sortBy,
  },
) => {
  const offset = ((page || 1) - 1) * 15;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);
  let dateFormated = BaseFormat.date(occurrence_date,).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',);

  const queryObj = {
    status: status ? `*${status}*` : undefined,
    code: code ? `*${code}*` : undefined,
    occurrence_date: occurrence_date ? dateFormated : undefined,
    reason: reason ? reason : undefined,
    financial_occ_type: financial_occ_type ? `*${financial_occ_type}*` : undefined,
    value: value ? value : undefined,
    sort: !Array.isArray(sortStrings,) ? sortStrings : sortStrings.join(',',) || undefined,
    limit: '15',
    offset: offset || undefined,
  };
  const query = `/drivers/${driverId}/occurrences${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(
    query,
  );
};

const get = (
  {
    fields,
    page,
    _id,
    full_name,
    logisticOperator_id,
    dispatch_type,
    sort,
    sortBy,
    address,
    cpf,
    phone,
    status,
  },
) => {
  const offset = ((page || 1) - 1) * 15;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);

  if (_id) { return BaseHttp.get(`/drivers/${_id}`,); }

  const queryObj = {
    full_name: full_name ? `/${full_name}/i` : undefined,
    cpf: cpf ? `/${cpf}/i` : undefined,
    phone: phone ? `/${phone}/i` : undefined,
    logisticOperator_id: logisticOperator_id || undefined,
    dispatch_type: dispatch_type || undefined,
    fields: fields ||
      'full_name,dispatch_type,status,occurrences,average_rating,last_order,recent_occurrences',
    sort: !Array.isArray(sortStrings,) ? sortStrings :
      sortStrings.join(',',) ||
      undefined,
    status: status?.join(',',) || undefined,
    'address.state': address?.state || undefined,
    'address.city': address?.city || undefined,
    limit: '15',
    offset: offset || undefined,
  };
  const query = `/drivers${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(
    query,
  );
};

const getAssignableDrivers = () => {
  return BaseHttp.get(
    '/drivers?status=APPROVED,MANUAL_APPROVED&dispatch_type=DEDICATED&limit=-1&fields=_id,full_name,dispatch_type,last_order,average_rating,status,cpf',
  );
};

const getDriverAssignedStores = ({ _id, },) => {
  return BaseHttp.get(
    `/drivers/${_id}/assigned-stores`,
  );
};

const getDriverOrders = ({ _id, },) => {
  return BaseHttp.get(
    `/logistic/orders/recent?driver.id=${_id}&fields=code,created_at,delivery_form.price,tracking_info.tracking_status,tracking_info.task_id`,
  );
};

const post = (driver,) => {
  return BaseHttp.post('/public/drivers', driver,);
};

const patch = (driverId, body,) => {
  return BaseHttp.patch(`/drivers/${driverId}`, body,);
};

const postDraft = (draft,) => {
  return BaseHttp.post('/public/drivers/drafts', draft,);
};

const postVechicle = (driverId, body,) => {
  return BaseHttp.post(`/drivers/${driverId}/vehicles`, body,);
};

const patchVechicle = (driverId, body,) => {
  return BaseHttp.patch(`/drivers/${driverId}/delivery-mode`, body,);
};

const removeVechicle = (driverId, vehicleId,) => {
  return BaseHttp.delete(`/drivers/${driverId}/vehicles/${vehicleId}`,);
};

const removeAttachment = (driverId, attachmentId,) => {
  return BaseHttp.delete(`/drivers/${driverId}/attachments/${attachmentId}`,);
};

const postAttachment = (driverId, body,) => {
  return BaseHttp.post(`/drivers/${driverId}/attachments`, body,);
};

const postOccurrence = (driverId, body,) => {
  return BaseHttp.post(`/drivers/${driverId}/occurrences`, body,);
};

const patchOccurrenceStatuses = ({ driverId, OccIds, status, },) => {
  return BaseHttp.patch(`/drivers/${driverId}/occurrences`, {
    status,
    occurrenceIds: OccIds,
  },);
};

const patchOccurrence = (driverId, occurrenceId, body,) => {
  return BaseHttp.patch(`/drivers/${driverId}/occurrences/${occurrenceId}`, body,);
};

const removeOccurrence = (driverId, occurrenceId,) => {
  return BaseHttp.delete(`/drivers/${driverId}/occurrences/${occurrenceId}`,);
};

const getDriverReports = ({ begin_date, end_date, },) => {
  return BaseHttp.get(`/drivers/reports/summary?begin_date>=${begin_date}&end_date<=${end_date}`,);
};

const exportDriverReports = ({ driverIds, begin_date, end_date, },) => {
  return BaseHttp.post('/drivers/reports/export', {
    driver_ids: driverIds,
    begin_date: {
      $gte: begin_date,
    },
    end_date: {
      $lte: end_date,
    },
  },);
};

const getDriversIndicators = ({ begin_date, end_date, },) => {
  return BaseHttp.get(`/drivers/summary?begin_date>=${begin_date}&end_date<=${end_date}`,);
};

const updateDriverTeams = ({ _id, added_teams, removed_teams, },) => {
  return BaseHttp.patch(`/drivers/${_id}/teams`, {
    added_teams,
    removed_teams,
  },);
};

const updateDriverDocs = ({ _id, attachments, cpf, },) => {
  return BaseHttp.patch(`/drivers/${_id}/update-documents`, {
    attachments,
    cpf,
  },);
};

const updateDriverAddress = ({ _id, address, },) => {
  return BaseHttp.patch(`/drivers/${_id}/update-acting-address`, {
    address,
  },);
};

const getDraftByCpf = ({ cpf, },) => {
  return BaseHttp.get(`/public/drivers/drafts/${cpf}`,);
};


const updateDriverStatuses = ({ driverIds, status, },) => {
  return BaseHttp.patch('/drivers/status', {
    drivers_ids: driverIds,
    trigger: 'bulk_update_drivers_status',
    use_filter: false,
    status,
  },);
};



const unsetFranchise = () => {
  return BaseHttp.unsetFranchise();
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

const patchDataBank = (driverId, body,) => {
  return BaseHttp.patch(`/drivers/${driverId}/bank-account/`, body,);
};

export default {
  get,
  getDriverOrders,
  getAssignableDrivers,
  post,
  patch,
  postDraft,
  patchDataBank,
  postVechicle,
  patchVechicle,
  removeVechicle,
  exportDriverReports,
  getDraftByCpf,
  getDriverReports,
  removeAttachment,
  postAttachment,
  getOccurrence,
  postOccurrence,
  patchOccurrence,
  removeOccurrence,
  getDriversIndicators,
  getDriverAssignedStores,
  updateDriverDocs,
  updateDriverTeams,
  updateDriverAddress,
  updateDriverStatuses,
  patchOccurrenceStatuses,
  unsetFranchise,
  handleError,
};
